var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navigation'),_c('div',{staticClass:"container px-4 mx-auto"},[_c('h1',{staticClass:"mb-3"},[_vm._v("Register")]),_c('register-form')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }